'use strict';

/**
 * @ngdoc function
 * @name thothApp.controller:ProjectIndexCtrl
 * @description
 * # ProjectIndexCtrl
 * Controller of the thothApp
 */
angular.module('thothApp.controllers')
  .controller('ProjectIndexCtrl', ['$scope', 'Project', 'FileSaver', 'SessionStorage', function ($scope, Project, FileSaver, SessionStorage) {
  }]);
